export const DEFAULT_PRIMARY = "#000000";
export const DEFAULT_ACCENT = "#0093c3";